import axios from '../api/axios';
import { baseURL, localURL } from '../config/url';
import localStorageService from './localStorageService';

const enrollStudentUrl = baseURL + '/students';
const enrollCourseUrl = baseURL + '/enrollments';
const enrollCourseBalance = baseURL + '/enrollments/balance';
const enrollCourseDetail = baseURL + '/enrollments/detail';
const enrollTransactionUrl = baseURL + '/transactions';
const feedbackUrl = baseURL + '/feedbacks';
const courseUrl = baseURL + '/courses';
const courseCategoryUrl = baseURL + '/course-categories';
const courseNameUrl = baseURL + '/course-names';
const courseTypeUrl = baseURL + '/course-types';
const COURSE_CATEGORY_STORAGE_KEY = 'PA_COURSE_CATEGORY_LIST';
const COURSE_NAME_STORAGE_KEY = 'PA_COURSE_NAME_LIST';

const getLocalCourseCategories = () => {
  try {
    return JSON.parse(localStorage.getItem(COURSE_CATEGORY_STORAGE_KEY)) || [];
  } catch (error) {
    return [];
  }
};

const saveLocalCourseCategories = (courseCategories) => {
  localStorage.setItem(
    COURSE_CATEGORY_STORAGE_KEY,
    JSON.stringify(courseCategories)
  );
};

const getLocalCourseNames = () => {
  try {
    return JSON.parse(localStorage.getItem(COURSE_NAME_STORAGE_KEY)) || [];
  } catch (error) {
    return [];
  }
};

const saveLocalCourseNames = (courseNames) => {
  localStorage.setItem(COURSE_NAME_STORAGE_KEY, JSON.stringify(courseNames));
};

const isNotFound = (error) =>
  error && error.response && error.response.status === 404;

const enrollStudentRequest = async (data) => {
  // console.log('enroll student url: ', enrollStudentUrl);
  // console.log('auth: ', localStorageService.getAuth());
  // console.log('param: ', data);
  return axios.post(`${enrollStudentUrl}`, data);
};

const enrollCourseRequest = async (data) => {
  // console.log('enroll student url: ', enrollCourseUrl);
  // console.log('auth: ', localStorageService.getAuth());
  // console.log('param: ', data);
  return axios.post(`${enrollCourseUrl}`, data);
};

const updateEnrollment = async (id, data) => {
  return axios.patch(`${enrollCourseUrl}/${id}`, data);
};

const enrollTransactionRequest = async (data) => {
  // console.log('enroll transaction url: ', enrollTransactionUrl);
  return axios.post(`${enrollTransactionUrl}`, data);
};

const makeFeedback = async (feedback) => {
  return axios.post(feedbackUrl, feedback);
};

const createCourse = async (data) => {
  return axios.post(courseUrl, data);
};

const createCourseCategory = async (data) => {
  try {
    return await axios.post(courseCategoryUrl, data);
  } catch (error) {
    if (!isNotFound(error)) {
      throw error;
    }
    const courseCategories = getLocalCourseCategories();
    const name = String(data.name || '').trim();
    const repeatedName = courseCategories.some((item) => item.name === name);
    if (repeatedName) {
      return Promise.reject({
        response: { data: { message: '课程类别已存在' } },
      });
    }
    const courseCategory = {
      _id: `local-course-category-${Date.now()}`,
      name,
      isActive: data.isActive !== false,
      weight: data.weight || (courseCategories.length + 1) * 10,
      courseValue:
        data.courseValue !== undefined && data.courseValue !== null
          ? data.courseValue
          : 2,
      isLocalOnly: true,
    };
    saveLocalCourseCategories([...courseCategories, courseCategory]);
    return { data: courseCategory };
  }
};

const updateCourseCategory = async (id, data) => {
  try {
    return await axios.patch(`${courseCategoryUrl}/${id}`, data);
  } catch (error) {
    if (!isNotFound(error)) {
      throw error;
    }
    const courseCategories = getLocalCourseCategories();
    const nextCourseCategories = courseCategories.map((item) =>
      item._id === id ? { ...item, ...data } : item
    );
    saveLocalCourseCategories(nextCourseCategories);
    return { data: nextCourseCategories.find((item) => item._id === id) };
  }
};

const createCourseName = async (data) => {
  try {
    return await axios.post(courseNameUrl, data);
  } catch (error) {
    if (!isNotFound(error)) {
      throw error;
    }
    const courseNames = getLocalCourseNames();
    const name = String(data.name || '').trim();
    const repeatedName = courseNames.some((item) => item.name === name);
    if (repeatedName) {
      return Promise.reject({
        response: { data: { message: '\u8bfe\u7a0b\u540d\u79f0\u5df2\u5b58\u5728' } },
      });
    }
    const courseName = {
      _id: `local-course-name-${Date.now()}`,
      name,
      isActive: data.isActive !== false,
      weight: data.weight || (courseNames.length + 1) * 10,
      isLocalOnly: true,
    };
    saveLocalCourseNames([...courseNames, courseName]);
    return { data: courseName };
  }
};

const deleteCourseName = async (id) => {
  try {
    return await axios.delete(`${courseNameUrl}/${id}`);
  } catch (error) {
    if (!isNotFound(error)) {
      throw error;
    }
    const courseNames = getLocalCourseNames().filter((item) => item._id !== id);
    saveLocalCourseNames(courseNames);
    return { data: { _id: id } };
  }
};

const updateCourseName = async (id, data) => {
  try {
    return await axios.patch(`${courseNameUrl}/${id}`, data);
  } catch (error) {
    if (!isNotFound(error)) {
      throw error;
    }
    const courseNames = getLocalCourseNames();
    const nextCourseNames = courseNames.map((item) =>
      item._id === id ? { ...item, ...data } : item
    );
    saveLocalCourseNames(nextCourseNames);
    return { data: nextCourseNames.find((item) => item._id === id) };
  }
};

const updateCourse = async (id, data) => {
  return axios.patch(`${courseUrl}/${id}`, data);
};

const updateCourseType = async (id, data) => {
  return axios.patch(`${courseTypeUrl}/${id}`, data);
};

const createCourseType = async (data) => {
  return axios.post(courseTypeUrl, data);
};

async function searchStudentRequest(url) {
  axios.get(url).then((res) => {
    // console.log('get result: ', res);
    return res;
  });
}

/**
 * archive
 */
async function searchBalance(enrollmentId) {
  const url = enrollCourseBalance + `/${enrollmentId}`;
  return axios.get(url);
}

async function searchDetail(enrollmentId) {
  const url = enrollCourseDetail + `/${enrollmentId}`;
  return axios.get(url);
}

const queryStudent = async (query) => {
  let url = baseURL + `/students?q=${query}`;
  return await axios.get(url);
};

const queryUser = async () => {
  let url = baseURL + '/users/list';
  return await axios.get(url);
};

const queryTeacher = async () => {
  let url = baseURL + '/users/teachers';
  return await axios.get(url);
};

const queryAdvisor = async () => {
  let url = baseURL + '/users/advisors';
  return await axios.get(url);
};

const queryCourse = async (includeInactive = false) => {
  let url = includeInactive ? `${courseUrl}?includeInactive=true` : courseUrl;
  return await axios.get(url);
};

const queryCourseCategory = async () => {
  try {
    return await axios.get(courseCategoryUrl);
  } catch (error) {
    if (!isNotFound(error)) {
      throw error;
    }
    return {
      data: getLocalCourseCategories().sort(
        (a, b) => Number(a.weight || 0) - Number(b.weight || 0)
      ),
    };
  }
};

const queryCourseName = async () => {
  try {
    return await axios.get(courseNameUrl);
  } catch (error) {
    if (!isNotFound(error)) {
      throw error;
    }
    return {
      data: getLocalCourseNames().sort(
        (a, b) => Number(a.weight || 0) - Number(b.weight || 0)
      ),
    };
  }
};

const queryCourseType = async (includeInactive = false) => {
  let url = includeInactive
    ? `${courseTypeUrl}?includeInactive=true`
    : courseTypeUrl;
  return await axios.get(url);
};

const queryEnrollCourse = async (id) => {
  let url = baseURL + `/enrollments/student/${id}`;
  return await axios.get(url);
};

export default {
  enrollStudentRequest,
  enrollCourseRequest,
  updateEnrollment,
  enrollTransactionRequest,
  makeFeedback,
  createCourse,
  createCourseCategory,
  updateCourseCategory,
  createCourseName,
  updateCourseName,
  createCourseType,
  deleteCourseName,
  updateCourse,
  updateCourseType,
  searchStudentRequest,
  searchBalance,
  searchDetail,
  queryStudent,
  queryUser,
  queryTeacher,
  queryCourse,
  queryCourseCategory,
  queryCourseName,
  queryCourseType,
  queryAdvisor,
  queryEnrollCourse,
};
